import script from "./PushNotificationsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PushNotificationsModal.vue?vue&type=script&setup=true&lang=ts"

import "./PushNotificationsModal.vue?vue&type=style&index=0&id=647662ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647662ba"]])

export default __exports__